export function assignLanes(segments){
 const ends=[],result=new Map();
 for(const s of [...segments].sort((a,b)=>Number(a.start_time)-Number(b.start_time)||Number(a.id)-Number(b.id))){let lane=ends.findIndex(end=>end<=Number(s.start_time));if(lane<0)lane=ends.length;ends[lane]=Number(s.end_time);result.set(s.id,lane)}
 return {lanes:result,count:Math.max(1,ends.length)};
}
export const planningLabels={UNPLANNED:'Ungeplant',ROUGH:'Grob geplant',FINE:'Fein geplant',COMPLETE:'Vollständig',CONFLICT:'Konflikt'};
